export const backCameraPattern = /\b(?:back|environment|rear|world)\b/i;
